var map = {
	"./1-1.json": "./levels/1-1.json",
	"./1-2.json": "./levels/1-2.json",
	"./1-3.json": "./levels/1-3.json",
	"./1-4.json": "./levels/1-4.json",
	"./1-5.json": "./levels/1-5.json",
	"./1-6.json": "./levels/1-6.json",
	"./2-1.json": "./levels/2-1.json",
	"./2-2.json": "./levels/2-2.json",
	"./2-3.json": "./levels/2-3.json",
	"./2-4.json": "./levels/2-4.json",
	"./2-5.json": "./levels/2-5.json",
	"./2-6.json": "./levels/2-6.json",
	"./3-1.json": "./levels/3-1.json",
	"./3-2.json": "./levels/3-2.json",
	"./3-3.json": "./levels/3-3.json",
	"./4-1.json": "./levels/4-1.json",
	"./corners.json": "./levels/corners.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./levels sync recursive ^\\.\\/.*\\.json$";